export const isCursorBetweenBrackets = (text, cursorPosition) => {
  if (cursorPosition == undefined) {
    return false;
  }
  let openBracketIndex = -1;
  let closeBracketIndex = -1;
  
  for (let i = cursorPosition - 1; i >= 0; i--) {
    if (text[i] === '[') {
      openBracketIndex = i;
      break;
    }
    if (text[i] === ']') {
      closeBracketIndex = i;
      break;
    }
  }
  
  if (openBracketIndex !== -1 && closeBracketIndex === -1) {
    return true;
  }
  
  return false;
};